module.exports = __webpack_public_path__ + "img/image-depan.54c9df0e.png";